import React from 'react';

export default function CurrentLevel(props) {
	return(
		<span className="current-level">
      {props.levelName.map((val) => <div>{val}</div>)}
		</span>
	)
}


// WEBPACK FOOTER //
// ./src/components/currentlevel.js